import { Chip, CircularProgress } from "@mui/material";

import type { CoachingArtifactStatus } from "../hooks/useCoachingArtifacts";

type DisplayStatus = CoachingArtifactStatus | "stalled";

const STATUS_LABELS: Record<DisplayStatus, string> = {
  generating: "Generating",
  created: "Created",
  failed: "Failed",
  stalled: "Stalled"
};

const STATUS_COLORS: Record<DisplayStatus, "default" | "primary" | "success" | "error" | "warning"> = {
  generating: "primary",
  created: "success",
  failed: "error",
  stalled: "warning"
};

interface CoachingArtifactStatusChipProps {
  status: CoachingArtifactStatus;
  isStalled?: boolean;
}

const CoachingArtifactStatusChip = ({ status, isStalled = false }: CoachingArtifactStatusChipProps) => {
  const displayStatus: DisplayStatus = status === "generating" && isStalled ? "stalled" : status;
  return (
    <Chip
      data-testid={`coaching-artifact-status-chip-${displayStatus}`}
      label={STATUS_LABELS[displayStatus]}
      color={STATUS_COLORS[displayStatus]}
      size="small"
      variant={displayStatus === "created" ? "filled" : "outlined"}
      icon={displayStatus === "generating" ? <CircularProgress size={12} thickness={6} /> : undefined}
    />
  );
};

export default CoachingArtifactStatusChip;
